var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9C2.5 8.04285 2.50106 7.37558 2.56879 6.87216C2.63456 6.38323 2.75486 6.12424 2.93955 5.93955C3.12424 5.75486 3.38323 5.63456 3.87216 5.56879C4.37558 5.50106 5.04285 5.5 6 5.5H18C18.9571 5.5 19.6244 5.50106 20.1278 5.56879C20.6168 5.63456 20.8758 5.75486 21.0604 5.93955C21.2451 6.12424 21.3654 6.38323 21.4312 6.87216C21.4989 7.37558 21.5 8.04285 21.5 9C21.5 9.24956 21.4989 9.38678 21.4862 9.48212C21.486 9.48332 21.4859 9.48449 21.4857 9.48564C21.4844 9.48581 21.4831 9.48599 21.4818 9.48617C21.3863 9.49895 21.249 9.5 21 9.5H3C2.75044 9.5 2.61322 9.49895 2.51788 9.48618C2.51668 9.48602 2.51551 9.48586 2.51436 9.4857C2.51419 9.48443 2.51401 9.48313 2.51383 9.48181C2.50105 9.38629 2.5 9.24901 2.5 9ZM2.93955 21.0604C2.75486 20.8758 2.63456 20.6168 2.56879 20.1278C2.50106 19.6244 2.5 18.9571 2.5 18V13C2.5 12.751 2.50105 12.6137 2.51383 12.5182C2.51401 12.5169 2.51419 12.5156 2.51436 12.5143C2.51551 12.5141 2.51668 12.514 2.51788 12.5138C2.61322 12.5011 2.75044 12.5 3 12.5H21C21.249 12.5 21.3863 12.501 21.4818 12.5138C21.4831 12.514 21.4844 12.5142 21.4857 12.5144C21.4859 12.5155 21.486 12.5167 21.4862 12.5179C21.4989 12.6132 21.5 12.7504 21.5 13V18C21.5 18.9571 21.4989 19.6244 21.4312 20.1278C21.3654 20.6168 21.2451 20.8758 21.0604 21.0604C20.8758 21.2451 20.6168 21.3654 20.1278 21.4312C19.6244 21.4989 18.9571 21.5 18 21.5H6C5.04285 21.5 4.37558 21.4989 3.87216 21.4312C3.38323 21.3654 3.12424 21.2451 2.93955 21.0604Z",
    fill: "#4F4E4E",
    stroke: "#4F4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V6V3ZM17 3V6V3Z",
    fill: "#4F4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V6M17 3V6",
    stroke: "#4F4E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.354381bbaddcdeb0ffbf7439106b27ac.svg";
export { ForwardRef as ReactComponent };